import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { addShowPopupEvent, addClosePopupEvent } from '../../../utilities/behavior-helpers/index.js';
import { getPlatformClass } from '../../../utilities/dom-helpers/index.js';
import { ButtonStyleTypes } from '../enums.js';

const platformClass = getPlatformClass();
class GenericButton extends s {
    constructor() {
        super(...arguments);
        this.styleType = ButtonStyleTypes.LIGHT;
        this.rtl = false;
        this.type = 'primary-button';
        this.closeModal = false; // if true, then button should close the popup
        this.showOnlyOnDesktop = false;
        this.modals = null;
    }
    firstUpdated() {
        var _a;
        if (this.popupId) {
            this.modals = document.querySelectorAll('cvt-modal');
            addShowPopupEvent(this.modals, this.popupId, this);
        }
        if (this.closeModal) {
            const modal = (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode;
            addClosePopupEvent(modal, this);
        }
        this.classList.add(platformClass);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.onClick)
            this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
        if (this.onClick)
            this.removeEventListener('click', this.onClick);
    }
    render() {
        return x `<slot></slot>`;
    }
    createRenderRoot() {
        return this;
    }
}
__decorate([
    n({ type: String })
], GenericButton.prototype, "styleType", void 0);
__decorate([
    n({ type: Boolean })
], GenericButton.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], GenericButton.prototype, "type", void 0);
__decorate([
    n({ type: Boolean })
], GenericButton.prototype, "closeModal", void 0);
__decorate([
    n({ type: Boolean })
], GenericButton.prototype, "showOnlyOnDesktop", void 0);
__decorate([
    n({ type: String })
], GenericButton.prototype, "popupId", void 0);
__decorate([
    n({ attribute: false })
], GenericButton.prototype, "onClick", void 0);
__decorate([
    t()
], GenericButton.prototype, "modals", void 0);
customElements.define('generic-button', GenericButton);

export { GenericButton };
